import TicketRootCauseEdit from './TicketRootCauseEdit';

export default TicketRootCauseEdit;
